import {Typography} from '@mui/material';
import React from 'react';

import {DataInfo} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {formatMasks} from 'presentation/utils';
import {StyledStack} from './styles';
import {ContactCardProps} from './types';

const {cellphoneEmpty, emailEmpty, title} = translations['pt-br'].privateFlow.contactCard;

function ContactCard({user}: ContactCardProps) {
	const emailValue = user?.email ? user.email : emailEmpty;
	const cellphoneValue = user?.cellphone ? formatMasks('phone', user.cellphone) : cellphoneEmpty;

	return (
		<StyledStack>
			<Typography variant="subtitle2" color="text.secondary">
				{title}
			</Typography>

			<DataInfo
				primaryText={formatMasks('phone', cellphoneValue)}
				primaryTextColor="text.primary"
				removeItemTextMargin
				iconName="phone-android-filled"
				listItemProps={{sx: {p: 0}}}
			/>
			<DataInfo
				primaryText={emailValue}
				primaryTextColor="text.primary"
				removeItemTextMargin
				iconName="mail-filled"
				listItemProps={{sx: {p: 0}}}
			/>
		</StyledStack>
	);
}

export {ContactCard};
